import { Service } from '../../../framework';
import { GlobalContext } from '../entities/global-context';

export class GlobalContextService extends Service {
  globalContext = this.framework.createEntity(GlobalContext);

  /**
   * Centralized way to set the active workspace id across the app.
   * - Updates GlobalContext
   * - Persists last successful workspace id
   */
  setActiveWorkspaceId(id: string | null): void {
    // Update global context first
    this.globalContext.workspaceId.set(id);

    // Best-effort persistence in browser environments
    if (typeof window !== 'undefined' && window.localStorage !== undefined) {
      try {
        const key = 'last_workspace_id';
        if (id) {
          window.localStorage.setItem(key, id);
        } else {
          window.localStorage.removeItem(key);
        }
      } catch {
        // ignore storage errors
      }
      try {
        // Emit a unified workspace change event for listeners
        window.dispatchEvent(
          new CustomEvent('affine:workspace:change', { detail: { id: id ?? '' } })
        );
      } catch {
        // ignore event errors
      }
    }
  }
}
